import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-98acfcb8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footerMusic"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "横滑可以切换上下首", -1));
const _hoisted_4 = {
  class: "footerRight"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-bofanganniu"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-zanting"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon liebiao",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-liebiao-"
})], -1));
const _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MusicDetail = _resolveComponent("MusicDetail");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "footerLeft",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.updateDetailShow && _ctx.updateDetailShow(...args))
  }, [_createElementVNode("img", {
    src: _ctx.playList[_ctx.playListIndex].al.picUrl,
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.playList[_ctx.playListIndex].name), 1), _hoisted_3])]), _createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("svg", {
    class: "icon liebiao",
    "aria-hidden": "true",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.playMusic && $options.playMusic(...args))
  }, _hoisted_6, 512)), [[_vShow, _ctx.isbtnShow]]), _withDirectives((_openBlock(), _createElementBlock("svg", {
    class: "icon liebiao",
    "aria-hidden": "true",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.playMusic && $options.playMusic(...args))
  }, _hoisted_8, 512)), [[_vShow, !_ctx.isbtnShow]]), _hoisted_9]), _createElementVNode("audio", {
    ref: "audio",
    src: `https://music.163.com/song/media/outer/url?id=${_ctx.playList[_ctx.playListIndex].id}.mp3`
  }, null, 8, _hoisted_10)]), _createVNode(_component_van_popup, {
    show: _ctx.detailShow,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => _ctx.detailShow = $event),
    position: "bottom",
    style: {
      height: '100%',
      width: '100%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_MusicDetail, {
      musicList: _ctx.playList[_ctx.playListIndex],
      playMusic: $options.playMusic,
      isbtnShow: _ctx.isbtnShow,
      addDuration: $options.addDuration,
      updateAudioCtime: $options.updateAudioCtime
    }, null, 8, ["musicList", "playMusic", "isbtnShow", "addDuration", "updateAudioCtime"])]),
    _: 1
  }, 8, ["show"])], 64);
}